// extracted by mini-css-extract-plugin
export var icon = "findOutMore-module--icon--1-lbz";
export var link = "findOutMore-module--link--PJLPb";
export var primary = "findOutMore-module--primary--RFcbh";
export var sbShowMain = "findOutMore-module--sb-show-main--kQx-1";
export var secondary = "findOutMore-module--secondary--0ANpn";